export function createColorPicker() {
    const colors = [
        { background: "#f0fdf4", border: "#b9f8cf" },
        { background: "#fef2f2", border: "#ffc9c9" },
        { background: "#eff6ff", border: "#bedbff" },
        { background: "#fefce8", border: "#fff085" }
    ];
    // return stable lookup function
    return (index: number) => {
        return colors[index % colors.length];
    };
}